import type { ProjectSearchable } from "@/lib/projects/project-search";

export const projectExternalId = (project: { readonly externalId?: string | null }): string =>
	project.externalId?.trim() || "";

/** Muted line under a project name: "{client} · {externalId}". Never prefixes the title. */
export const projectSecondaryLabel = (project: ProjectSearchable, clientFallback = ""): string =>
	[project.client?.name || clientFallback, projectExternalId(project)].filter(Boolean).join(" · ");

/** Compact "{name} · {externalId}" for filters and search. */
export const projectNameIdLabel = (project: {
	readonly externalId?: string | null;
	readonly name?: string | null;
}): string => [project.name?.trim(), projectExternalId(project)].filter(Boolean).join(" · ");

/** Time-entry hint: "{client} · {project} · {externalId} / {task}". */
export const projectTaskHint = (input: {
	readonly client?: string | null;
	readonly externalId?: string | null;
	readonly name?: string | null;
	readonly task?: string | null;
}): string => {
	const left = [input.client, input.name?.trim(), projectExternalId(input)].filter(Boolean).join(" · ");
	return [left, input.task].filter(Boolean).join(" / ");
};
